let isPpvMainEventTimeEnabledCached: boolean;
let ppvMainEventTimeCached: number;
let concurrentPpvMainEventTimeCached: string;

function isPpvMainEventTimeEnabled() {
    if (typeof isPpvMainEventTimeEnabledCached !== 'undefined') {
        return isPpvMainEventTimeEnabledCached;
    }

    try {
        const isFeatureEnabled = window.dazn.features.isEnabledAnonymous(
            'f_ar_showppv_main_eventtime'
        );
        isPpvMainEventTimeEnabledCached = isFeatureEnabled;
        return isPpvMainEventTimeEnabledCached;
    } catch (e) {
        return false;
    }
}

function getPpvMainEventTime(): number {
    if (typeof ppvMainEventTimeCached !== 'undefined') {
        return ppvMainEventTimeCached;
    }

    try {
        ppvMainEventTimeCached =
            window.dazn.features.getVariableIntegerAnonymous(
                'f_ar_showppv_main_eventtime',
                'ppvMainEventTime'
            ) ?? 0;
        return ppvMainEventTimeCached;
    } catch (e) {
        return 0;
    }
}

function getConcurrentPpvMainEventTime(): any {
    if (typeof concurrentPpvMainEventTimeCached !== 'undefined') {
        return concurrentPpvMainEventTimeCached;
    }

    try {
        concurrentPpvMainEventTimeCached =
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_showppv_main_eventtime',
                'ppvConcurrentDifference'
            ) ?? '';
        return concurrentPpvMainEventTimeCached;
    } catch (e) {
        return '';
    }
}

export {
    isPpvMainEventTimeEnabled,
    getPpvMainEventTime,
    getConcurrentPpvMainEventTime
};
